import { IMemberLinkedInProfile } from '@copilot/common/store/models/redux';
import { createFetchOneSelector } from '@copilot/common/store/selectors/fetch';
import { LINKEDIN_PROFILE } from './constant';

export const selectLinkedInProfile = createFetchOneSelector<IMemberLinkedInProfile>(LINKEDIN_PROFILE);
